import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import MyLeads from './pages/MyLeads';
import MyTeamPage from './pages/MyTeamPage';

const PrivateRoute = ({ children }) => {
  const session = sessionStorage.getItem('rbac_session');
  return session ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/portal/:clientId/login" element={<Navigate to="/" replace />} />
        <Route path="/portal/:clientId/leads" element={
          <PrivateRoute>
            <MyLeads />
          </PrivateRoute>
        } />
        <Route path="/portal/:clientId/my-team" element={
          <PrivateRoute>
            <MyTeamPage />
          </PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
